import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MdClose } from "react-icons/md";
import useTicketSuffix from "@/features/task/hooks/useTicketSuffix";
const FormHeader = ({ task, taskId, onClose }) => {
    const { formatTicketCode } = useTicketSuffix();
    const resolvedTaskId = task?.id ?? taskId;
    const isEditing = resolvedTaskId !== undefined;
    const headerTitle = isEditing
        ? `Modification : ${formatTicketCode(resolvedTaskId)}`
        : "Créer une tâche";
    return (_jsxs("header", { className: "relative border-b bg-gray-100", children: [_jsxs("div", { className: "flex flex-col gap-2 p-4 pr-12 md:flex-row md:items-center md:justify-between", children: [_jsx("h1", { className: "text-m font-bold text-blue-900 md:text-2xl", children: headerTitle }), task?.title && (_jsx("p", { className: "text-sm text-gray-600 md:text-base", children: task.title }))] }), onClose && (_jsx("button", { type: "button", onClick: onClose, className: "absolute top-1/2 right-4 -translate-y-1/2 text-gray-600 transition hover:text-gray-800", "aria-label": "Fermer", children: _jsx(MdClose, { size: 24 }) }))] }));
};
export default FormHeader;
